import "./large-table.styles.scss";
import LargeTableRow from "../large-table-row/large-table-row.component";
import Button from "../button/button.component";

const getArrayType = (array, tableName) => {
  switch (tableName) {
    case "Tickets":
      return array.map((ticket) => {
        if (!ticket) return null;
        return {
          asset_serial: ticket?.assets[0]?.asset_serial,
          contact_name: ticket?.contact?.name,
          ...ticket,
        };
      });
    default:
      return array;
  }
};

const LargeTable = ({
  array = [],
  tableName,
  keyValue,
  label,
  fields,
  allowNavigate,
  selectable = false,
  selectedIds = [],
  onToggleSelect,
  onToggleSelectAll,
}) => {
  const tableArray = getArrayType(array, tableName);
  const allSelected =
    selectable &&
    tableArray?.length > 0 &&
    tableArray.every((item) => selectedIds.includes(item[keyValue]));
  return (
    <div className="large-table tcs-container">
      <div className="table-header">
        {selectable && (
          <div className="select-all-control">
            <input
              type="checkbox"
              className="select-all-checkbox"
              checked={allSelected}
              onChange={() => onToggleSelectAll?.(tableArray, !allSelected)}
            />
            <Button
              label={allSelected ? "Deselect All" : "Select All"}
              onClick={() => onToggleSelectAll?.(tableArray, !allSelected)}
            />
          </div>
        )}
        <h2>{tableName}</h2>
      </div>
      <div className="table-body scrollbar">
        {tableArray?.length > 0 &&
          tableArray?.map((item, index) => (
            <LargeTableRow
              key={item[keyValue] || index}
              item={item}
              label={label}
              fields={fields}
              variant={index % 2 === 0 ? "primary" : "secondary"}
              allowNavigate={allowNavigate}
              selectable={selectable}
              keyValue={keyValue}
              selected={selectedIds.includes(item[keyValue])}
              onToggleSelect={onToggleSelect}
            />
          ))}
      </div>
    </div>
  );
};

export default LargeTable;
